import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { CustomerAgent } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerAgentService extends TmsWebBaseEditCreateService<CustomerAgent, CustomerAgent> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('CustomerAgent', $localize`Customer Agent`, httpService, notificationService);
  }

  getForCustomer(customerId: string): Observable<CustomerAgent[]> {
    return this.httpService.get<CustomerAgent[]>(`${this.apiUrl}/Customer/${customerId}`);
  }
}
